import { LockIcon, styled, css } from 'canoe';
import React from 'react';

import { useMultiNodes, useSelection } from 'craft/hooks';
import { CollectionTargetLocation, ContentCollection } from 'craft/types';

const StyledContainer = styled.div`
  ${({ theme }) => css`
    display: inline-flex;
    align-items: center;
    color: ${theme.colors.White};
    padding: 0 ${theme.spaces.xs};
    line-height: ${theme.fonts.body.lineHeight};
    background-color: ${theme.colors.OnyxGrayL10};
  `}
`;

export const TextFromACollectionMessage: React.FC = () => {
  const { selection } = useSelection();

  const nodeIds = selection.all;
  const { collections } = useMultiNodes(nodeIds, (node) => ({
    collections: node?.data.custom.collections,
  }));

  // either no collection is being used
  // either the targetLocation of the collections being used don't target the content's Text
  if (
    !collections?.length ||
    !collections.some(
      (collection: ContentCollection) =>
        collection.targetLocation === CollectionTargetLocation.Text,
    )
  ) {
    return null;
  }

  return (
    <StyledContainer>
      <LockIcon color="GlitterGrayL20" />
      Text from a Collection
    </StyledContainer>
  );
};
